import React, {useMemo, useState} from "react";
import {format, startOfMonth, endOfMonth} from "date-fns";
import LocalMallRoundedIcon from '@material-ui/icons/LocalMallRounded';
import LocalShippingRoundedIcon from '@material-ui/icons/LocalShippingRounded';
import AccountBalanceWalletRoundedIcon from '@material-ui/icons/AccountBalanceWalletRounded';
import paginationFactory, {PaginationProvider} from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import {Row, Col, Form, InputGroup, Button} from "react-bootstrap";

import {InfoCard} from "../../core/InfoCard";
import {Card, CardBody, Pagination} from "../../../../_metronic/_partials/controls";
import {getHandlerTableChange, NoRecordsFoundMessage} from "../../../../_metronic/_helpers";
import {useBalancesUIContext} from "../../../contexts/BalancesUIContext";
import {count, price} from "../../../../utils/formatter";
import * as uiHelpers from "../ProductTable/ui.helpers";

export function BalanceTabContent(props) {
  const context = useBalancesUIContext();
  const {
    currentDate,
    onChangeDate,
    columns,
    listLoading,
    totalCount,
    salesList,
    balanceSummary,
  } = props;

  const [date, setDate] = useState(format(new Date(), 'yyyy-MM'));

  const {queryParams, setQueryParams} = useMemo(() => ({
    queryParams: context.queryParams,
    setQueryParams: context.setQueryParams,
  }), [context]);

  const pagination = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
  };

  if (!balanceSummary) return null;

  const splitDate = currentDate.split('-');
  const year = format(new Date(splitDate), 'yyyy');
  const month = format(new Date(splitDate), 'M');
  const startDate = format(startOfMonth(new Date(splitDate)), 'yyyy.MM.dd');
  const endDate = format(endOfMonth(new Date(splitDate)), 'yyyy.MM.dd');
  const calcDate = format(new Date(balanceSummary.calcDate), 'yyyy년 MM월 dd일 이후');

  return (
    <div>
      <div className="d-flex justify-content-end">
        <p className="text-muted">구매자 결제 완료 및 배송완료 주문건에 한하여 정산이 진행됩니다.</p>
      </div>

      {/* cards */}
      <Row>
        <Col xs={6} md={3}>
          <Card className="flex-grow-1 text-center shadow-none">
            <CardBody className="p-7">
              <div style={{fontSize: 20}}>{year} 년</div>
              <div className="font-weight-boldest text-ellipsis">
                <span style={{fontSize: 50}}>{month}월</span>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xs={6} md={3} className="d-flex">
          <InfoCard color="info" Icon={LocalMallRoundedIcon}>
            <div className="font-weight-boldest text-ellipsis">
              <span style={{fontSize: 20}}>
                {balanceSummary && count(balanceSummary.totalOrderCount)}
              </span>
              <span className="font-size-sm">건</span>
            </div>
            <div className="font-size-sm">총 주문 수</div>
          </InfoCard>
        </Col>
        <Col xs={6} md={3}  className="d-flex">
          <InfoCard color="success" Icon={LocalShippingRoundedIcon}>
            <div className="font-weight-boldest text-ellipsis">
              <span style={{fontSize: 20}}>
                {balanceSummary && count(balanceSummary.totalOrderCount)}
              </span>
              <span className="font-size-sm">개</span>
            </div>
            <div className="font-size-sm">총 판매 수량</div>
          </InfoCard>
        </Col>
        <Col xs={6} md={3}  className="d-flex">
          <InfoCard color="danger" Icon={AccountBalanceWalletRoundedIcon}>
            <div className="font-weight-boldest text-ellipsis">
              <span style={{fontSize: 20}}>
                {balanceSummary && price(balanceSummary.totalCalcPrice)}
              </span>
            </div>
            <div className="font-size-sm">총 정산금액</div>
          </InfoCard>
        </Col>
      </Row>

      {/* form */}
      <Row className="my-20">
        <Col xs={12} md={4} className="d-flex align-items-center mb-3">
          <InputGroup>
            <Form.Control
              as="select"
              value={date}
              onChange={e => setDate(e.target.value)}
            >
              <option value="2020-09">2020년 9월</option>
              <option value="2020-08">2020년 8월</option>
              <option value="2020-07">2020년 7월</option>
              <option value="2020-06">2020년 6월</option>
              <option value="2020-05">2020년 5월</option>
              <option value="2020-04">2020년 4월</option>
              <option value="2020-03">2020년 3월</option>
              <option value="2020-02">2020년 2월</option>
              <option value="2020-01">2020년 1월</option>
            </Form.Control>
            <InputGroup.Append>
              <Button
                variant="primary"
                className="font-weight-boldest font-size-h6-xs w-100px"
                onClick={() => onChangeDate(date)}
              >
                조회
              </Button>
            </InputGroup.Append>
          </InputGroup>
        </Col>
        <Col xs={12} md={4} className="d-flex align-items-center justify-content-end mb-3">
          <p className="font-size-h4 m-0">
            <span className="text-dark-50 mr-5">정산 예정일</span>
            <span className="font-weight-bolder ">{calcDate}</span>
          </p>
        </Col>
        <Col xs={12} md={4} className="d-flex align-items-center justify-content-end mb-3">
          <p className="font-size-h4 m-0">
            <span className="text-dark-50 mr-5">판매 일자</span>
            <span className="font-weight-bolder ">{startDate} ~ {endDate}</span>
          </p>
        </Col>
      </Row>

      {/* table */}
      <PaginationProvider pagination={paginationFactory(pagination)}>
        {({paginationProps, paginationTableProps}) => (
          <Pagination isLoading={listLoading} paginationProps={paginationProps}>
            <BootstrapTable
              remote
              bootstrap4
              keyField="id"
              hover
              bordered
              columns={columns}
              wrapperClasses="table-responsive"
              classes="table table-head-light table-vertical-center overflow-hidden"
              data={salesList === null ? [] : salesList}
              noDataIndication={<NoRecordsFoundMessage entities={salesList}/>}
              onTableChange={getHandlerTableChange(setQueryParams)}
              {...paginationTableProps}
            />
          </Pagination>
        )}
      </PaginationProvider>

    </div>
  )
}
